var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpload2 = function SvgUpload2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Upload2_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.837 61.225v7.55H21.163v-7.55h-5.374v10.238c0 1.487 1.2 2.687 2.687 2.687h43.05c1.488 0 2.688-1.2 2.688-2.688V61.226h-5.375Z",
    fill: "#DC9B32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.375 27.337c0-6.962-5.663-12.624-12.625-12.624-1.612 0-3.163.312-4.575.862A16.091 16.091 0 0 0 35.388 5.85c-6.813 0-12.625 4.213-14.988 10.162a10.341 10.341 0 0 0-3.25-.5c-5.937 0-10.75 4.8-10.75 10.738 0 .875.1 1.75.325 2.563A12.603 12.603 0 0 0 0 39.974c0 6.962 5.662 12.612 12.637 12.612h54.738C74.35 52.587 80 46.938 80 39.975c0-6.988-5.65-12.638-12.625-12.638Z",
    fill: "#CAD9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.088 48.038a12.55 12.55 0 0 0 1.675-6.275c0-6.988-5.638-12.625-12.613-12.625 0-6.963-5.663-12.626-12.625-12.626a12.25 12.25 0 0 0-4.563.875c-2.475-5.725-8.175-9.725-14.8-9.725-5.087 0-9.6 2.338-12.55 6.013C24.4 9 29.526 5.887 35.4 5.887c6.625 0 12.313 3.988 14.788 9.726a12.365 12.365 0 0 1 4.575-.875c6.962 0 12.612 5.65 12.612 12.612C74.35 27.35 80 33 80 40c0 3.05-1.1 5.862-2.912 8.038Z",
    fill: "#9CB9DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.75 46.614 39.375 33.75 50 46.614h-5.14V61.25H33.89V46.614h-5.14Z",
    fill: "#274673",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.175 47.362 40 34.025l10.825 13.337h-5.238v15.175H34.412V47.362h-5.237Z",
    fill: "#4376B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Upload2_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h80v80H0z"
  })))));
};
export default SvgUpload2;